import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import { cfpFieldGroups } from '../field_group/CFPFields';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

// FRS 4.2.1 - VRF Indoor Unit form (project library)
export const INDOOR_FORMS = [
  { id: 'cassette', name: 'Cassette' },
  { id: 'wall', name: 'Wall' },
  { id: 'ceiling', name: 'Ceiling' },
  { id: 'duct', name: 'Duct' },
  { id: 'floor', name: 'Floor' },
];

export class VRFIndoorDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getData() {
    return this.formRef.getFormData([]);
  }

  render() {
    const {
      name,
      indoor_form,
      cooling_capacity,
      unit,
      fan_power_input,
      cfp_value,
      cfp_unit,
      description,
      image,
    } = this.props.indoor;

    const { t, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="vrf-indoor-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-indoor-form"
          field="indoorForm"
          componentClass="select"
          label={t('indoor form')}
          value={indoor_form}
          defaultDirty={true}
          {...customAttr}
        >
          {INDOOR_FORMS.map(item => this.renderOption(item, 'vrfif'))}
        </FieldGroup>
        <FieldGroup
          id="vrf-indoor-cooling-capacity"
          field="coolingCap"
          type="number"
          label={t('cooling capacity')}
          placeholder="12"
          value={cooling_capacity}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-indoor-unit"
          field="unitId"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(u => this.renderOption(u, 'vrfu'))}
        </FieldGroup>
        <FieldGroup
          id="vrf-indoor-fan-power"
          field="fanPower"
          type="number"
          label={t('fan power (kW)')}
          placeholder="0.1"
          value={fan_power_input}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'fan_power_input')}
          {...customAttr}
        />
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id="vrf-indoor-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

VRFIndoorDetail.defaultProps = {
  indoor: {},
};

const mapStateToProps = state => ({
  units: state.reference.ac.coolingCapacityUnit,
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    null,
    null,
    { withRef: true },
  )(VRFIndoorDetail),
);



// WEBPACK FOOTER //
// ./src/components/vrf/VRFIndoorDetail.js